<template class="secure">
  <div class="users-list">
    <b-row>
      <b-col>
        <b-row>
          <h1 class="table-header">Users</h1>
          <b-row class="sort">
            <i
              class="fas fa-caret-square-up triangle"
              @click="sortAscending()"
            ></i>
            <i
              class="fas fa-caret-square-down triangle"
              @click="sortDescending()"
            ></i>
          </b-row>
        </b-row>
      </b-col>

      <b-col>
        <b-row class="search">
          <input
            type="text"
            class="search-input"
            @keyup.enter="search()"
            v-model="searchValue"
            placeholder="-- Enter username --"
          />
          <b-button class="search-button" @click="search()">Search </b-button>
        </b-row>
      </b-col>
    </b-row>
    <div class="table-wrap">
      <h1 class="not-found" v-if="isFound">NOT FOUND</h1>

      <b-table
        :busy="isBusy"
        class="table"
        sticky-header
        head-variant="light"
        striped
        hover
        :items="users"
      ></b-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchValue: "",
      users: [],
      isFound: false
    };
  },
  created() {
    this.$store.dispatch("getUsers").then(() => {
      if (!this.isBusy) this.user = this.usersList;
      this.search();
    });
  },
  computed: {
    usersList() {
      return this.$store.getters.usersList;
    },
    isBusy() {
      return this.$store.getters.authStatus === "loading";
    }
  },
  methods: {
    search() {
      this.isFound = false;
      this.users = this.usersList.filter(user =>
        user.username.toLowerCase().includes(this.searchValue.toLowerCase())
      );
      if (!this.users.length) {
        this.isFound = true;
      }
    },

    sortDescending() {
      this.users.sort((a, b) => b.id - a.id);
    },
    sortAscending() {
      this.users.sort((a, b) => a.id - b.id);
    }
  }
};
</script>

<style>
.secure {
  background-color: #213a4f;
  padding-bottom: 50px;

  overflow-y: hidden;
}

.users-list {
  margin: 25px !important;
  padding: 40px;

  background: #fff;
  border: 1px dashed #939da6;
  box-sizing: border-box;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.15);
  overflow: auto;
}

.table-wrap {
  min-height: calc(100vh - 278px) !important;

  padding: 20px 0;
}

.table {
  max-height: calc(100vh - 360px) !important;
}

.table th,
.table td {
  max-width: 300px;
  word-wrap: break-word;

  border-top: 0px solid #dee2e6 !important;
}

.table tbody + tbody {
  border-top: 1px dashed #e9e9e9;
}

.sort {
  display: flex;
  align-items: center;
  flex-direction: column;

  padding-left: 20px;
}

.triangle {
  width: 22px !important;
  height: 22px !important;

  line-height: 1.2 !important;
  font-size: 16px !important;
  color: #213a4f !important;

  cursor: pointer;
}

.search-input {
  margin: 3px 20px 0 auto;
  padding: 0 12px;

  width: 21vw;
  height: 32px;

  border: 1px solid #e9e9e9;
  box-sizing: border-box;
  border-radius: 0;
}

.search-button {
  width: 90px;
  height: 40px;

  background: #213a4f;
  border-radius: 3px;

  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #fff;
}

.not-found {
  margin-top: 100px;
  text-align: center;
  color: red;
}

@media (max-width: 1112px) {
  .table th,
  .table td {
    max-width: 100px;
    font-size: 10px;
    padding: 5px;
  }
}

@media (max-width: 827px) {
  .users-list {
    padding: 40px 10px;
  }
  .table-wrap {
    min-height: calc(100vh - 290px) !important;
    padding: 0 0;
  }

  .table {
    max-height: calc(100vh - 300px) !important;
  }
}

@media (max-width: 560px) {
  .users-list {
    padding: 20px 5px;
    margin: 10px !important;
  }
  .table-wrap {
    min-height: calc(100vh - 200px) !important;
  }

  h1 {
    font-size: 20px;
  }

  .triangle {
    font-size: 10px !important;
    height: 12px !important;
  }

  .sort {
    padding-left: 5px;
  }

  .table {
    margin-top: 5px;
    max-height: calc(100vh - 200px) !important;
  }

  .search-button {
    width: 40px;
    height: 20px;
    margin-top: 1px;

    font-size: 10px;
    line-height: 20px;
  }

  .search-input {
    margin: 0px 5px 0 auto;
    padding: 0 0px;

    width: 21vw;
    height: 22px;

    border: 1px solid #e9e9e9;
    box-sizing: border-box;
    border-radius: 0;
  }

  .search-input::placeholder {
    font-size: 8px;
    line-height: 22px;
  }
}
</style>
